import Footer from './Footer'

export default Footer
// eslint-disable-next-line import/export
export * from './Footer'
